<template>
    <div :class="method_class">
        <template v-if="is_editing">
            <np-input
                v-if="method_kee === 'paypal_address'"
                :check_config="false"
                :name="`${method_kee}_payment_method`"
                :id="`${method_kee}_payment_method`"
                :key="`${method_kee}_payment_method`"
                :label="method_text"
                :no-wrapper="false"
                :maxlength="100"
                :required="true"
                :rules="['valid_email']"
                v-model="payment_method[method_kee]">
            </np-input>
            <np-input
                v-else
                :check_config="false"
                :name="`${method_kee}_payment_method_mid`"
                :id="`${method_kee}_payment_method_mid`"
                :key="`${method_kee}_payment_method_mid`"
                :label="method_text"
                :no-wrapper="false"
                :maxlength="15"
                :required="true"
                :rules="['numeric']"
                v-model="payment_method[method_kee]">
            </np-input>
        </template>
        <np-entry
            v-else
            :label="method_text"
            mode="inline"
            :model-value="ecom_payment_method[method_kee]">
        </np-entry>
    </div>
</template>

<script>
import {NPInput,} from "netpify/components";

export default {
    name: "ecom_payment_method.vue",
    props: {
        ecom_payment_method: Object,
        formatter: Function,
        parameter: String,
        is_editing: {type: Boolean, default: false}
    },
    components: {
        'np-input': NPInput
    },
    data: function () {
        return {
            method_class: 'col-md-12',
            method_kee: '',
            method_text: '-',
            method_fields_format: {
                'paypal_MID': 'col-md-4',
                'paypal_address': 'col-md-8',
            },
            email_address_fields: [
                'paypal_address'
            ],
            payment_method:{}
        }
    },
    mounted() {
        this.payment_method = this.ecom_payment_method
        this.method_kee = Object.entries(this.payment_method)[0][0] || null;
        this.method_class = this.method_fields_format.hasOwnProperty(this.method_kee) ? this.method_fields_format[this.method_kee] : 'col-md-12';
        if (this.method_kee === 'paypal_address') {
            this.method_text = 'paypal email';
        } else {
            this.method_text = this.formatter(this.parameter, this.method_kee);
        }
    },
    beforeDestroy() {
        this.payment_method = {}
    },
    methods: {

    },
    computed: {
        is_email_address_field: function () {
            return this.email_address_fields.includes(this.method_kee)
        }
    }

}
</script>